export function generateId(prefix = ''): string {
  try {
    return `${prefix}${crypto.randomUUID()}`;
  } catch (error) {
    console.error('Unable to generate id', { prefix, error });
    throw error;
  }
}
